import React, { useState, useEffect } from 'react';
import { Tabs, Tab, Box } from '@material-ui/core';
import { isMobile } from 'react-device-detect';
import { useLazyQuery } from '@apollo/client';
import BrowseForm from '../BrowseForm';
import FormReservation from '../FormReservation';
import AirLoader from '../AirLoader';
import useStyles from './useStyles';
import Dictionary from '../../utils/dictionary';
import { GET_BROWSE_INITIAL_INFORMATION } from '../../operations/queries';
import { SESSION_STORAGE_SEARCH_TYPE, COOKIE_KEYS } from '../../utils/constants';
import { getSessionStorageItem } from '../../operations/sessionStorage/utils';
import { getCookies } from '../../utils/common';
import useDictionary from '../../hooks/useDictionary';

const TabPanel = ({ children, value, index, ...other }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
};

const a11yProps = (index) => {
  return {
    id: `flight-tab-${index}`,
    'aria-controls': `flight-tabpanel-${index}`,
  };
};

const SearchTabs = ({ handleErrorBanner }) => {
  const getDictionary = useDictionary(Dictionary);
  const [
    getBrowseInitialInformation,
    { loading: initialInformationLoading, data: queryInitialData, error: errorInitialData },
  ] = useLazyQuery(GET_BROWSE_INITIAL_INFORMATION);

  const [initialData, setInitialData] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const classes = useStyles();
  const searchType = new URLSearchParams(window.location.search).get('booking');
  const selectedTab = getSessionStorageItem(SESSION_STORAGE_SEARCH_TYPE);
  const defaultValue =
    (selectedTab && selectedTab.tab === 'browse' ? 1 : 0) || (searchType === 'browse' ? 1 : 0);
  const [value, setValue] = React.useState(defaultValue);

  useEffect(() => {
    if (!value) {
      getBrowseInitialInformation({
        variables: { includeSoldOutSailings: true, onlyActive: false },
      });
    }
    // eslint-disable-next-line
  }, [value]);

  useEffect(() => {
    const profile = getCookies(COOKIE_KEYS.ACCESS_TOKEN);
    if (profile) {
      setIsLoggedIn(profile);
    }
  }, []);

  useEffect(() => {
    if (queryInitialData) {
      setInitialData(queryInitialData);
    }
  }, [queryInitialData]);

  useEffect(() => {
    if (errorInitialData) {
      handleErrorBanner({
        title: getDictionary(Dictionary.airFlightBookFlightsReservationErrorInitialDataTitle.key),
        message: getDictionary(
          Dictionary.airFlightBookFlightsReservationErrorInitialDataDescription.key,
        ),
      });
    }
    // eslint-disable-next-line
  }, errorInitialData);

  const handleChange = (_event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box className={classes.rootSearchTabs}>
      <AirLoader open={initialInformationLoading} />
      <Box style={{ borderBottom: 1, borderColor: 'divider' }}>
        <div>
          <h2>
            {getDictionary(
              isLoggedIn ? Dictionary.airSearchTabsTitle.key : Dictionary.airAddCruiseDetails.key,
            )}
          </h2>
        </div>
        <Tabs value={value} onChange={handleChange} aria-label="search tabs">
          <Tab
            disableRipple
            label={getDictionary(Dictionary.airSearchTabsFirstTabLabel.key)}
            {...a11yProps(0)}
          />
          <Tab
            disableRipple
            label={getDictionary(Dictionary.airSearchTabsSeccondTabLabel.key)}
            {...a11yProps(1)}
          />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0} className={classes.tabPanel}>
        <FormReservation
          isMobile={isMobile}
          initialData={initialData}
          handleErrorBanner={handleErrorBanner}
        />
      </TabPanel>
      <TabPanel value={value} index={1} className={classes.tabPanel}>
        <BrowseForm handleErrorBanner={handleErrorBanner} />
      </TabPanel>
    </Box>
  );
};

export default SearchTabs;
